/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: '電話鈴聲 1',
  [RINGS_TYPE.Phone_Ring2]: '電話鈴聲 2',
  [RINGS_TYPE.Acoustic_Dreams]: '原聲樂器',
  [RINGS_TYPE.Air_Raid]: '空襲聲',
  [RINGS_TYPE.Allusive]: '暗示聲',
  [RINGS_TYPE.Attention]: '注意聲',
  [RINGS_TYPE.Blub_Blub]: '咕嚕聲',
  [RINGS_TYPE.Buzzy]: '嗡嗡聲',
  [RINGS_TYPE.Channel_Open]: '頻道開放',
  [RINGS_TYPE.Contemplation]: '沉思',
  [RINGS_TYPE.Crystal_Ball]: '水晶',
  [RINGS_TYPE.Disco]: '迪斯可',
  [RINGS_TYPE.Door_Bell]: '門鈴聲',
  [RINGS_TYPE.Fairy]: '小精靈',
  [RINGS_TYPE.Fast_Bells]: '快速鐘聲',
  [RINGS_TYPE.High_Gong]: '鳴鑼聲',
  [RINGS_TYPE.Immersion]: '鋼琴音符',
  [RINGS_TYPE.Indeed]: '強調聲',
  [RINGS_TYPE.Lazy_Day]: '放鬆',
  [RINGS_TYPE.Neural_Funk]: '腦波',
  [RINGS_TYPE.Nice]: '愉悅',
  [RINGS_TYPE.Ring]: '鈴聲',
  [RINGS_TYPE.Ringing_Bells]: '鈴響',
  [RINGS_TYPE.Simple]: '簡單',
  [RINGS_TYPE.Soothing]: '療癒',
  [RINGS_TYPE.Sunshine]: '陽光',
  [RINGS_TYPE.Off]: '關閉',
  add: '新增',
  delete: '刪除',
  play: '播放',
  cancel: '取消',
  confirmToDelete: '刪除 {name}？',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
